import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { Modal } from '../Modal';
import styles from './ErrorModal.module.css';
const SEVERITY_ICON_MAP = {
    error: 'inputError',
    warning: 'warning',
    info: 'informationFilled',
    success: 'successGreen',
};
function getSeverityIcon(severity) {
    return SEVERITY_ICON_MAP[severity] ?? 'informationFilled';
}
export const ErrorModal = ({ isOpen, onClose, title, message, severity = 'error', actionable, critical = false, 'data-testid': testId = 'error-modal', }) => {
    const handleClose = critical ? () => { } : onClose;
    return (_jsx(Modal, { isOpen: isOpen, onClose: handleClose, title: title, closeOnBackdropClick: !critical, showCloseButton: !critical, renderInPortal: true, "data-testid": testId, children: _jsxs("div", { className: styles.errorModalContent, "data-testid": `${testId}-content`, children: [_jsx("div", { className: styles.errorModalIcon, children: _jsx(Icon, { name: getSeverityIcon(severity), alt: severity, className: styles.icon, "data-testid": `${testId}-icon` }) }), _jsx("div", { className: styles.errorModalMessage, "data-testid": `${testId}-message`, children: message }), actionable && (_jsx("div", { className: styles.errorModalActions, "data-testid": `${testId}-actions`, children: _jsx(Button, { onClick: () => {
                            actionable.action();
                            if (!critical) {
                                onClose();
                            }
                        }, variant: 'primary', size: 'medium', dataTestId: `${testId}-action-button`, children: actionable.label }) }))] }) }));
};
